import React from 'react';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { ICustomCheckboxProps } from 'store/ducks/Global/types';
import * as Styled from './CustomCheckbox.styled';

const { useToken } = theme;

export const CustomCheckbox: React.FC<ICustomCheckboxProps> = ({
  label,
  ...rest
}) => {
  const { token } = useToken();
  const { scheme } = useSelector((state: RootState) => state.global);

  return (
    <Styled.StyledCheckbox token={token} scheme={scheme} {...rest}>
      {label}
    </Styled.StyledCheckbox>
  );
};
